import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sqg-notifications" }
const _hoisted_2 = { class: "sqg-notifications__line" }
const _hoisted_3 = {
  key: 0,
  class: "sqg-notifications__noResults"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Aucune notification ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "sqg-notifications__results"
}
const _hoisted_8 = { class: "sqg-notifications__global" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-exclamation" }, null, -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "sqg-notifications__actions" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

import Header from '@/components/Header.vue';
import {useUserStore} from "@/stores/user";
import {storeToRefs} from "pinia";
import Loader from '@/components/Loader.vue';
import {useFoldersStore} from "@/stores/folders";
import {onMounted, ref} from "vue";

//Stores

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
//STORE folders
const foldersStore = useFoldersStore();

const loader = ref(false);
const notifsToDisplay = ref<Array<any>>([]);

const validateFolder = (folderId: string) => {
  loader.value = true;
  foldersStore.validateFolder(folderId)
      .then(() => foldersStore.getFolders()
          .then(() => getNotifications()));
};

const removeAll = () => {
  loader.value = true;
  notifsToDisplay.value.forEach(notif => {
    const count = ref(0);
    userStore.deleteNotification(notif.id).then(() => {
      count.value++;
      if (count.value === notifsToDisplay.value.length) getNotifications();
    });
  });
}

const removeNotification = (notification: any) => {
  loader.value = true;
  userStore.deleteNotification(notification.id).then(() => getNotifications());
}

const getNotifications = () => {
  loader.value = true;
  userStore.getNotifications().then((response) => {
    notifsToDisplay.value = response;
    loader.value = false;
  });
}

onMounted(() => {
  getNotifications();
});

return (_ctx: any,_cache: any) => {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      icone: "fa-solid fa-bell",
      title: "Centre des notifications"
    }),
    _createElementVNode("div", _hoisted_2, [
      (notifsToDisplay.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sqg-notifications__clear clickable",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (removeAll()))
          }, "Tout supprimer"))
        : _createCommentVNode("", true)
    ]),
    (notifsToDisplay.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (loader.value)
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(notifsToDisplay.value, (notification, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "sqg-notifications__item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("strong", null, _toDisplayString(new Date(notification.creationDate).toLocaleString()), 1),
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createElementVNode("div", {
                        class: "sqg-notifications__content",
                        innerHTML: notification.content
                      }, null, 8, _hoisted_10)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (notification.notifType==='dossier_en_attente_validation')
                      ? (_openBlock(), _createBlock(_component_Popper, {
                          key: 0,
                          arrow: true,
                          hover: true,
                          content: "Valider le dossier"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "fa-solid fa-circle-check clickable",
                              onClick: ($event: any) => (validateFolder(notification.folderId))
                            }, null, 8, _hoisted_12)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Popper, {
                      arrow: true,
                      hover: true,
                      content: "Supprimer la notification"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "fas fa-trash clickable",
                          onClick: ($event: any) => (removeNotification(notification))
                        }, null, 8, _hoisted_13)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
        ]))
  ]))
}
}

})